export interface Bounds {
	x: number;
	y: number;
	width: number;
	height: number;
}

const PADDING = 20;

/** По модели, а не по `getBBox`: вне браузера layout не работает. Петля связи тоже входит в габарит. */
const getBoundsFromModel = (elementRegistry: {
	getAll: () => {
		parent?: unknown;
		x?: number;
		y?: number;
		width?: number;
		height?: number;
		waypoints?: { x: number; y: number }[];
	}[];
}): Bounds | null => {
	const corners: { x: number; y: number }[] = [];

	for (const element of elementRegistry.getAll()) {
		if (!element.parent) continue;
		if (element.waypoints) {
			corners.push(...element.waypoints.map(({ x, y }) => ({ x, y })));
			continue;
		}
		if (typeof element.x !== "number" || typeof element.y !== "number") continue;
		corners.push({ x: element.x, y: element.y });
		corners.push({ x: element.x + (element.width ?? 0), y: element.y + (element.height ?? 0) });
	}

	if (!corners.length) return null;

	const xs = corners.map((c) => c.x);
	const ys = corners.map((c) => c.y);
	const x = Math.min(...xs) - PADDING;
	const y = Math.min(...ys) - PADDING;

	return {
		x,
		y,
		width: Math.max(...xs) - Math.min(...xs) + PADDING * 2,
		height: Math.max(...ys) - Math.min(...ys) + PADDING * 2,
	};
};

export default getBoundsFromModel;
